export default __webpack_public_path__ + "sharp-sans-bold-e6569ef7f54f49ef99bcf1fe93853d23.bundle.woff";